import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'

import Styles from './EmptyPerformance.module.scss'

const EmptyPerformance = () => {
  const { t } = useTranslation()
  return (
    <div className={Styles.message} data-testid="empty-performance">
      <img
        className={Styles.imageForEmpty}
        src="/images/empty-performance.svg"
        alt="Waiting for orders history"
      />
      <Text variant="title-3" gutter={8} align="center">
        {t('performance.orders-performance.empty.title')}
      </Text>
      <Text variant="subtitle" className={Styles.dimmed} align="center">
        {t('performance.orders-performance.empty.description')}
      </Text>
    </div>
  )
}

export default EmptyPerformance
